import { t } from 'i18next';
import { Dispatch, SetStateAction, useMemo } from 'react';

import { ActionBar } from '@/lib/components/ActionBar';
import { DeleteIconSolid, DistributeContactsIcon } from '@/lib/icon';
import { Button } from '@/lib/v2/components/Button';
import { CopyIcon } from '@/lib/v2/icons/solid';

import { useFeatureFlag } from '@/src/application/hooks/util/useFeatureFlag';
import { quantifier } from '@/src/ContactsModule/utils/quantifier';

interface ISegmentsActionBarProps {
  contactSelection: number;
  segmentsSwitcher: string;
  distributeIsDisabled: boolean;
  setOpenDeleteModal: Dispatch<SetStateAction<boolean>>;
  setOpenDuplicateModal: Dispatch<SetStateAction<boolean>>;
  setOpenDistributeModal: Dispatch<SetStateAction<boolean>>;
}

// TODO: Refactor all actionBar modals (ContactsActionBAr, GroupsActionBar, TagsActionBar, SegmentsActionBar ActionBar)
export const SegmentsActionBar = ({
  contactSelection,
  segmentsSwitcher,
  distributeIsDisabled,
  setOpenDeleteModal,
  setOpenDuplicateModal,
  setOpenDistributeModal,
}: ISegmentsActionBarProps) => {
  const isActiveDistributeSegment = useFeatureFlag('distributeSegment');
  const iconsActions = useMemo(
    () => [
      {
        id: 'duplicate',
        icon: <CopyIcon />,
        onClick: () => setOpenDuplicateModal(true),
        tooltip: t('SEGMENT_DUPLICATE_MODAL.title'),
        flagOn: segmentsSwitcher !== 'eCommerce',
        disabled: contactSelection !== 1,
        disabledTooltip: t('SEGMENT_DUPLICATE_MODAL.duplicateOnly1'),
      },
      {
        id: 'distribute-contacts',
        icon: <DistributeContactsIcon />,
        onClick: () => setOpenDistributeModal(true),
        tooltip: t('MANAGE_DISTRIBUTE_CONTACTS_MODAL.title'),
        flagOn: isActiveDistributeSegment,
        disabled: distributeIsDisabled,
        disabledTooltip: t('SEGMENT_DUPLICATE_MODAL.duplicateOnly1'),
      },
      {
        id: 'delete',
        icon: <DeleteIconSolid />,
        onClick: () => setOpenDeleteModal(true),
        tooltip:
          contactSelection === 1
            ? t('GROUP_DELETE_MODAL.title')
            : t('GROUP_DELETE_MODAL.titlePlural'),
        flagOn: true,
        disabled: false,
        disabledTooltip: '',
      },
    ],
    [
      contactSelection,
      distributeIsDisabled,
      isActiveDistributeSegment,
      segmentsSwitcher,
      setOpenDeleteModal,
      setOpenDistributeModal,
      setOpenDuplicateModal,
    ]
  );

  return (
    <ActionBar id="segmentActionBar">
      <div>
        <section className="flex h-full items-center">
          <div className="text-xs ml-10 text-white" style={{ fontSize: '12px' }}>
            {`${quantifier(contactSelection) ?? 0} ${t('CONTACTS_ACTIONS_DROPDOWN.Selected')}`}
          </div>
          <div className="ml-4">
            {/* {actionBarDropdown && (
              <ContactsDropDown
                icon={<DropdownCellPhoneIcon />}
                title="Actions"
                {...dropdownOptions}
              />
            )} */}
          </div>
          <div className="ml-5 flex">
            {iconsActions.map((element) => {
              const {
                disabled,
                icon,
                id,
                disabledTooltip,
                tooltip,
                onClick: handleOnClick,
              } = element;
              return (
                element.flagOn && (
                  <div key={id} className="mr-2">
                    <Button
                      fullWidth
                      standard
                      disabled={disabled}
                      iconLeft={icon}
                      id={id}
                      tooltip={disabled ? disabledTooltip : tooltip}
                      onClick={handleOnClick}
                    />
                  </div>
                )
              );
            })}
          </div>
        </section>
      </div>
    </ActionBar>
  );
};
